import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filteredReports: [], // initial empty array
  newfilteredReports: [],
  followupReports: [],
  otherExpenses:[]
};

const filteredDataSlice = createSlice({
  name: "filteredData",
  initialState,
  reducers: {
    // Ignore undefined payload so mount-time `dispatch(setFilteredReports())`
    // does not wipe data already seeded by DashFilters.
    setFilteredReports: (state, action) => {
      if (action.payload === undefined) return;
      state.filteredReports = action.payload;
    },
    setNewfilteredReports: (state, action) => {
      if (action.payload === undefined) return;
      state.newfilteredReports = action.payload;
    },
    setFollowupReports: (state, action) => {
      if (action.payload === undefined) return;
      state.followupReports = action.payload;
    },
    setOtheeExpensesData: (state, action) => {
      state.otherExpenses = action.payload;
    },
  },
});

export const { setFilteredReports, setNewfilteredReports, setFollowupReports,setOtheeExpensesData } =
  filteredDataSlice.actions;

export default filteredDataSlice.reducer;
